import { CloudStagingListWebComponent } from './component/CloudStagingListWebComponent';
import { WEB_COMPONENT_CLOUD_STAGING_LIST } from '../../webcomponents.constants';

export { CloudStagingListWebComponent };

window.customElements.define(WEB_COMPONENT_CLOUD_STAGING_LIST, CloudStagingListWebComponent);
